// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M22,19h-1c0-8.8-7.2-16-16-16V2C14.4,2,22,9.6,22,19z" />
	<path d="M5,7v1c6.1,0,11,4.9,11,11h1C17,12.4,11.6,7,5,7z" />
	<path d="M5,12v1c3.3,0,6,2.7,6,6h1C12,15.1,8.9,12,5,12z" />
	<path d="M5,17c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S6.1,17,5,17z M5,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S5.6,20,5,20z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-wifi-DdFKxT8d.js.map
